export default {
  switchAccount: "切換帳號",
  login: "登錄",
  loginFirst: "請先登錄帳號",
  start: "開始答題",
  hasHistory: "您之前已經回答了部分題目，",
  loadHistory: "是否繼續上次回答？",
  cancel: "取消",
  confirm: "確認",
  contact: "填寫聯繫方式有機率獲得額外獎勵喔！",
  completed: "恭喜您完成了問卷",
  leaveMessage: "留下您的聯繫方式可獲得抽獎機會",
  enterEmail: "請輸入您的電子郵箱：",
  enterPhone: "請輸入您的手機號碼：",
  submit: "提交",
  leave: "暫填寫，離開問卷",
  submitted: "已提交，",
  thanks: "感謝您的信任與支持",
  opinion: "請談談您的想法",
  prev: "上一題",
  next: "下一題",
  unlikely: "不可能",
  likely: "極有可能",
  claimYourRewards: "這是給您的獎勵",
  rewardSent: "獎勵已發放",
  checkInGame: "請進入遊戲內查看",
  copy: "複製",
  copied: "複製成功",
  selectTips: "請選擇選項",
  multipleTips: "此題為多選題，請選擇多個選項",
  leastChoose: "最多選擇xxx項",
  maxChoose: "最少選擇xxx項",
  mustAnswer: "請回答此題",
  mustWrite: "請填寫內容",
  checkEmail: "請輸入正確格式的電子郵箱",
  checkPhone: "請輸入正確格式的手機號碼",
  isAnswer: "您已答題",
  unStart: "活動未開啟",
  end: "活動已結束",
  server: "請選擇伺服器",
  role: "請選擇角色",
  noRole: "暫無角色",
  common: "系統繁忙，請稍後再試",
  title: "問卷調查",
  titleAward: "有獎問卷",
  leastWord: "您的輸入小於最小輸入字數xxx",
  maxWord: "您的輸入已超過最大字數xxx",
  singleChoose: "單選",
  multiChoose: "多選",
  matrix: "矩陣題",
  score: "評分題",
  textLimit: "(xx-yyy字)",
  coverGiftTitle: "填問卷領豪禮",
  "-20001": "未登錄",
  "-20002": "缺少必要參數",
  "-20003": "找不到問卷",
  "-20004": "問卷配置中",
  "-20005": "問卷已停止",
  "-20006": "問卷活動未開始",
  "-20007": "問卷活動已結束",
  "-20008": "已經答題",
  "-20010": "發獎失敗",
  "-20011": "該問卷已經發獎",
  "-20012": "還未答題",
  "-20016": "遊戲ID無效",
};
